module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/team/mark-mancini-d50d38708c9bdbb94a4b7838aea80c2c.jpg";